import React, { Component } from "react"
import { noYes, oneTill4plus, notEmpWorkBefore, notEmpWorkDuration } from "../../variables/ComboValues";
import { updateElement } from "../Tree/Utils.js"
import { box_element } from './ParentEmployment'

// TODO: get data from DB && Update to DB
export const  NotEmployed_microLegend = {
    "notemp_workbefore": "האם עבדת בעבר תמורת שכר?",
    "notemp_howlong": "(כשכיר או כעצמאי) - כמה זמן אינך עובד?", 
    "notemp_why": "למה אתה לא עובד?",
    "notemp_look4work": "מה עשית כדי למצוא עבודה? (בדיקת כוחות/ ידע/ מוטיבציה)",
    "notenough": "אין מספיק הצעות עבודה",
    "noreview": "מאתר/ת הצעות עבודה, אך לא מגיע/ה לשלב הראיונות",
    "nopass": "מתקבל/ת לראיונות אך לא עובר/ת אותם",
    "nostay": "מתקבל/ת לעבודה אך לא נשאר/ת בה מספיק זמן",
    "other": "אחר",
    "places_last3y": "בכמה מקומות עבדת ב-3 השנים האחרונות?"
}
const emptyProduct = [{
    "notemp_workbefore": "",
    "notemp_howlong": "",
    "notemp_why": "",
    "notemp_look4work": "",
    "notenough": "",
    "noreview": "",
    "nopass": "",
    "nostay": "",
    "other": "",
    "places_last3y": ""
}]
export class ParentNotEmployed extends Component {

    constructor(props) {
      super(props)
      this.state = { products: typeof this.props.data === "undefined" ? emptyProduct :  this.props.data}
      this.onSaveTable = this.onSaveTable.bind(this)
      this.handleProductTable = this.handleProductTable.bind(this)
    }
    
    handleProductTable(evt) {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(memberPostId, this.state.products, subTableId, "group" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            products={this.state.products} 
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable } = this.props
      // console.log("General - products", products)
     
     // if (typeof products !== "undefined")
      var product = products
      const cellData=[{
            type: "select",
            options: notEmpWorkBefore, // ["כן, עבדתי מחוץ לבית","כן, עבדתי מהבית","גם וגם","עד כה בעיקר למדתי (בתיכון, מכללה, אוניברסיטה)",
            // "עד כה הייתי בשירות צבאי / לאומי / אזרחי","עד כה הייתי עקר/ת בית", "לא עבדתי","אחר"],
            name: "notemp_workbefore",
            value: product.notemp_workbefore,
            id: product.id,
            style: {width: "190px"},
            edit: true
          },{
            type: "select",
            options: notEmpWorkDuration, // ["עד חצי שנה","עד שנה","שנתיים עד 5 שנים","6-10 שנים","למעלה מ-10 שנים","אחר"],
            name: "notemp_howlong",
            value: product.notemp_howlong,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "textarea",
            name: "notemp_why",
            value: product.notemp_why,
            id: product.id,
            style: {width: "300px"},
            edit: true
          },{
            type: "textarea",
            name: "notemp_look4work",
            value: product.notemp_look4work,
            id: product.id,
            style: {width: "300px"},
            edit: true
          },{
            newsection: "למבקשי עבודה - האם נתקלת באחד או ביותר מהקשיים הבאים בתהליך חיפוש עבודה?",
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "notenough",
            value: product.notenough,
            id: product.id,
            style: {width: "90px"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "noreview",
            value: product.noreview,
            id: product.id,
            style: {width: "160px !important"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "nopass",
            value: product.nopass,
            id: product.id,
            style: {width: "160px !important"},
            edit: true
          },{
            type: "select",
            options: noYes, // ["לא","כן"],
            name: "nostay",
            value: product.nostay,
            id: product.id,
            style: {width: "160px !important"},
            edit: true
          },{
            type: "text",
            name: "other",
            value: product.other,
            id: product.id,
            style: {width: "180px"},
            edit: true
          },{
            type: "select",
            options: oneTill4plus, // ["0","1","2","3","4+"],
            name: "places_last3y",
            value: product.places_last3y,
            id: product.id,
            style: {width: "90px"},
            edit: true
          }] 
      return (box_element(tableTitle, onSaveTable, onProductTableUpdate, product, cellData, NotEmployed_microLegend ))
    }
  }

